<template>
  <div>
    <h1 class="title is-4">Vendedores</h1>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">Identificacion</label>
          <div class="control">
            <input
              v-model="vendedor.codigo"
              class="input"
              type="text"
              placeholder="Nombre"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">Nombre</label>
          <div class="control">
            <input
              v-model="vendedor.nombre"
              class="input"
              type="text"
              placeholder="Nombre"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">Porcentaje</label>
          <div class="control">
            <input
              v-model="vendedor.porcentaje"
              class="input"
              type="number"
              placeholder="Porcentaje"
            />
          </div>
        </div>
      </div>
    </div>
    <button class="button is-primary" @click="save">Guardar</button>
    <button class="button is-light" @click="cancel">Cancelar</button>

    <hr />
    <table class="table">
      <thead>
        <tr>
          <th>Identificación</th>
          <th>Nombre</th>
          <th>Porcentaje</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in vendedores" :key="index">
          <td class="fontMono">{{ item.codigo }}</td>
          <td>{{ item.nombre }}</td>
          <td>{{ item.porcentaje }}%</td>
          <td>
            <div class="buttons has-addons">
              <button class="button is-small" @click="edit(item)">
                <span class="icon is-small">
                  <span class="material-icons"> mode_edit </span>
                </span>
              </button>
              <button class="button is-small is-danger" @click="eliminar(item)">
                <span class="icon is-small">
                  <span class="material-icons"> delete_forever </span>
                </span>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapState } from "vuex";
import apiServices from "@/services/yungol-services";
export default {
  data() {
    return {
      vendedor: {
        _id: null,
        codigo: null,
        nombre: null,
        porcentaje: null,
      },
      vendedores: [],
    };
  },
  computed: {
    ...mapState(["modalnotification"]),
    resultnotification() {
      return this.modalnotification.result.aceptar;
    },
  },
  methods: {
    async save() {
      try {
        if (!this.vendedor.codigo) {
          this.$store.dispatch("notify", {
            message: "Debe ingresar los días",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        if (!this.vendedor.nombre) {
          this.$store.dispatch("notify", {
            message: "Debe ingresar un nombre",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        if (!this.vendedor.porcentaje) {
          this.$store.dispatch("notify", {
            message: "Debe ingresar el porcentaje",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        if (this.vendedor._id) {
          await apiServices.post(`/editvendedor`, this.vendedor);
        } else {
          await apiServices.post(`/createvendedor`, this.vendedor);
        }
        this.vendedor = {
          _id: null,
          codigo: null,
          nombre: null,
          porcentaje: null,
        };
        this.find();
      } catch (err) {
        console.log(err);
      }
    },
    async find() {
      try {
        const result = await apiServices.get(`/getvendedores`);
        if (result.data) {
          this.vendedores = result.data;
        }
      } catch (err) {
        console.log(err);
      }
    },
    async edit(vendedor) {
      try {
        this.vendedor = JSON.parse(JSON.stringify(vendedor));
        window.scrollTo({ top: 0, behavior: "smooth" });
      } catch (err) {
        console.log(err);
      }
    },
    cancel() {
      this.vendedor = {
        _id: null,
        codigo: null,
        nombre: null,
        porcentaje: null,
      };
    },
    eliminar(vendedor) {
      this.$store.commit("changenotificationmodal", {
        info: {
          title: "Atención!",
          message: "Realmente desea eliminar el vendedor?",
          clase: "is-danger",
          data: vendedor._id,
        },
      });
    },
    async deletevendedor(id) {
      try {
        await apiServices.delete(`/deletevendedor/${id}`);
        this.find();
      } catch (err) {
        console.log(err);
      }
    },
  },
  watch: {
    resultnotification(nv, ov) {
      if (nv) {
        this.deletevendedor(this.modalnotification.result.data);
      }
    },
  },
  created() {
    this.find();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/comisiones/Vendedores.vue